import * as React from "react";

import _ from "lodash";
import { PartialDeep } from "type-fest";

import { ChecklistDocumentStyles } from "../lib/model/documentStyles";
import { migrateFontFamily } from "../lib/model/fonts";
import { defaultDocumentStyles } from "../lib/state/defaultStyles";

import { useLibraryState } from "./useEditorState";

export const useDocumentStyles = (libraryEntry?: number): ChecklistDocumentStyles => {
  // const documentStylePreferences = useCurrentEditorDocument((state) => state.styles, {});
  const documentStylePreferences = useLibraryState((state) => {
    const retrievalIndex = libraryEntry ?? state.editingEntry;
    if (retrievalIndex !== null && retrievalIndex >= 0 && retrievalIndex < state.entries.length) {
      return state.entries[retrievalIndex].present.styles;
    } else {
      return null;
    }
  });

  const result = React.useMemo(
    () => mergeStylesWithDefaults(documentStylePreferences ?? {}),
    [documentStylePreferences]
  );

  return result;
};

export const mergeStylesWithDefaults = (
  preferences: PartialDeep<ChecklistDocumentStyles> = {}
): ChecklistDocumentStyles => {
  const merged = _.merge(_.cloneDeep(defaultDocumentStyles), preferences);
  if (merged.checklistDocument.fontFamily) {
    merged.checklistDocument.fontFamily = migrateFontFamily(merged.checklistDocument.fontFamily);
  }
  return merged;
};
